module.exports = __webpack_public_path__ + "static/media/placeholder.7d5b9751.jpg";